// 1. All imports first
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import axios from "axios";

// 2. Polyfills / global code
if (typeof crypto !== "undefined" && !crypto.randomUUID) {
  crypto.randomUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0, v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
}

// 3. Global Axios defaults
axios.defaults.withCredentials = true; 
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || "http://197.156.76.122";

// 4. ReactDOM render
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

